import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgPlusSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15 8.00073H1M8 1.00073V15.0007"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgPlusSmall.displayName = 'SvgPlusSmall';
const PlusSmall = withForgeIconProps(SvgPlusSmall, {
  name: 'Plus',
  usage: 'Use to adjust or increment up.',
  related: 'add',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default PlusSmall;
